export default "__VITE_ASSET__CO_72zRZ__"